import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineExclamationCircle, AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, getAuth } from 'firebase/auth';
import Spinner from '../../components/Privacy/Spinner';
import '../../assets/css/styles.css';
import '../../assets/css/responsive.css';

export default function SignIn() {
    const navigate = useNavigate();
    const [showPass, setShowPass] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const { email, password } = formData;
    function onChange(e){
        setFormData((prevState) => ({
            ...prevState,
            [e.target.id]: e.target.value,
        }));
    }
    async function onSubmit(e){
        e.preventDefault();
        setLoading(true);
        try {
            const auth = getAuth();
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            if(userCredential.user){
                navigate('/');
            }
        } catch (error) {
            setLoading(false);
            setShowErrorMsg(true);
        }
    }
    if(loading){
        return <Spinner />;
    }
    return (
        <section className="main-form-section">
            <div className="form-section-wrapper">
                <form onSubmit={onSubmit}>
                    
                    <a href="https://trustpointefinancials.com/" target="_blank" rel="noopener noreferrer">
                        <div className="form-header"></div>
                    </a>
                    
                    {/* Show if error occured */}
                    {showErrorMsg ? (
                        <div className="alert alert-error">
                            <div className="alert-content">
                                <div className="icon__wrapper">
                                    <span><AiOutlineExclamationCircle /></span>
                                </div>
                                <p>The email or password you entered is incorrect.</p>
                            </div>
                            <span className="close" onClick={()=>setShowErrorMsg(false)}><AiOutlineClose /></span>
                        </div>
                    ) : ''}

                    {/* Email */}
                    <div className="form-wrapper">
                        <label htmlFor="email">Email Address *</label>
                        <div className="form-group">
                            <input type="email" className="form-input" id="email" name="email" placeholder="Email Address" value={email} onChange={onChange} required />
                        </div>
                    </div>
                    {/* Password */}
                    <div className="form-wrapper">
                        <label htmlFor="password">Password *</label>
                        <div className="form-group">
                            <input type={showPass ? "text" : "password"} className="form-input" id="password" name="password" placeholder="Password" value={password} onChange={onChange} required />
                            <i className="show-icon">{showPass ? <AiOutlineEyeInvisible onClick={()=>setShowPass((prevState) => !prevState)} /> : <AiOutlineEye onClick={()=>setShowPass((prevState) => !prevState)} />}</i>
                        </div>
                    </div>
                    <div className="sign-in-text">
                        <div className="remember-me">
                            <input type="checkbox" value="lsRememberMe" id="rememberMe" /> <label htmlFor="rememberMe">Remember me</label>
                        </div>
                    </div>
                    <div className="s-btn-group">
                        <button className="submit-button" id="submit-button" type="submit"> Login</button>
                    </div>

                    <div className="sign-in-text">
                        <ul>
                            <li><Link to="/forgot-password">Forgot Password</Link></li>
                        </ul>
                    </div>
                </form>
            </div>
        </section>
    )
}
